import dayjs from "dayjs";
import { date, number, object } from "yup";

import { DiscountTypeEnum } from "@/features/shared";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  discount: 0,
  discountInput: 0,
  discountType: DiscountTypeEnum.FIXED_AMOUNT,
  taxable: false,
  totalIncludesTax: false,
  taxAmount: 0,
  taxPercentage: 11,
  subtotal: 0,
  grandTotal: 0,
  externalPurchaseOrder: null,
  purchaseOrderProductVariants: [],
};

export const VALIDATION_SCHEMA = object().shape({
  seller: object().required("Harus diisi"),
  paymentTerm: object().required("Harus diisi"),
  transactionDate: date().required("Harus diisi"),
  subtotal: number()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? undefined : value
    )
    .required("Harus diisi")
    .min(0, "Minimal 0"),
});
